import { SVGProps } from 'react';

const RectangleCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 4v16m0-16H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h11m0-16a8 8 0 1 0 0 16m0-16a8 8 0 1 1 0 16"
    />
  </svg>
);
export default RectangleCircle;
